/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Status_Publishing_MarkersInputs */



/**
* | output |
* | --- |
* | "Publishing markers" |
*
* @param {Iconik_Publish_Status_Publishing_MarkersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_status_publishing_markers = /** @type {((inputs?: Iconik_Publish_Status_Publishing_MarkersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Status_Publishing_MarkersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Publishing markers")
	if (locale === "de") return /** @type {LocalizedString} */ ("Publishing markers")
	if (locale === "it") return /** @type {LocalizedString} */ ("Publishing markers")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Publishing markers")
	if (locale === "es") return /** @type {LocalizedString} */ ("Publishing markers")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Publishing markers")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Publishing markers")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Publishing markers")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Publishing markers")
	return /** @type {LocalizedString} */ ("Publishing markers")
});